/**
 * @interface
 */
export default class DragAndDropInterface
{
	onDragStart() {}

	getDragBoundary() {}

	getFinalFrom() {}

	getFinalTo() {}
}
